<p-tabView (onChange)="loadData(lastGridEvent)" [(activeIndex)]="activeIndex">
    <ng-container *ngFor="let tab of tabs">
        <p-tabPanel [header]="tab.header">
            <div class="flex justify-content-end mb-2">
                <p-button *ngIf="allowWrite" label="Añadir tipo de incidencia" icon="pi pi-plus"
                    (click)="edit(null, tab.type)" />
            </div>
            <p-table styleClass="mt-4" #grid [value]="incidentTypes" [lazy]="true" (onLazyLoad)="loadData($event)"
                [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-incidentType>
                    <tr (dblclick)="edit(incidentType)">
                        <td>{{incidentType.name}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="delete(incidentType)" [rounded]="true"
                                    [text]="false" severity="danger">
                                    <i class="pi pi-trash"></i>
                                </p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="10">{{ tab.emptyMessage }}</td>
                    </tr>
                </ng-template>
            </p-table>

        </p-tabPanel>
    </ng-container>
</p-tabView>
<p-confirmDialog></p-confirmDialog>